import React from "react";
import { BillingScreen } from "./view";
import { BillingController } from "./controller";
import { styles } from "./styles";
import NavigationService from "../../../utils/navigation-service";

export class Billing extends React.Component {
  static navigationOptions = {
    title: "Billing"
  };

  constructor(props) {
    super(props);
    this.controller = new BillingController(props);
  }

  render() {
    const { navigation } = this.props;

    NavigationService.setTopLevelNavigator(navigation);

    return (
      <BillingScreen
        {...this.props}
        controller={this.controller}
        styles={styles}
      />
    );
  }
}
